import { Assert } from "../../Assert";
import { PartialNullable } from "../../Extensions";
import { PropertyChange } from "../../PropertyChange";
import { Property } from "../../RadObject";
import { ElementRef } from "../ElementRef";
import { JsxFragment } from "../JsxFragment";
import { IToolbarItem, ToolbarItem, ToolbarItemPropertyValues } from "./ToolbarItem";
import { NAMESPACE } from "./_Namespace";

import "./ToolbarSplitter.scss";

export type ToolbarSplitterPropertyValues =
    ToolbarItemPropertyValues
    & {
    };

export type ToolbarSplitterProperties = {
    [name in keyof ToolbarSplitterPropertyValues]: Property<ToolbarSplitterPropertyValues[name]>
};

export interface IToolbarSplitter extends IToolbarItem, ToolbarSplitterProperties
{
}

export class ToolbarSplitter extends ToolbarItem implements IToolbarSplitter
{
    // #region Static

    public static override classNamespace = NAMESPACE + "ToolbarSplitter";
    public static override className = "ToolbarSplitter";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<ToolbarSplitterPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Global Variables

    protected _spanElementRef!: ElementRef;

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<ToolbarSplitterPropertyValues>)
    {
        super(propertyValues);

        this.addCssClass("rad-control-toolbar-splitter");
    }

    // #endregion

    // #region Overrides

    protected override __initializeProperties(propertyValues: ToolbarSplitterPropertyValues)
    {
        super.__initializeProperties(propertyValues);

        this._spanElementRef = new ElementRef();
    }

    protected override _createElementHtml(children?: JsxFragment | string | (JsxFragment | string | undefined)[])
    {
        return (
            <span>
                <span ref={this._containerElementRef} class="rad-container">
                    <span ref={this._spanElementRef}></span>
                    {children}
                </span>
            </span>
        );
    }
    protected override _textChanged(change: PropertyChange<string>)
    {
        super._textChanged(change);

        Assert.isNotNullOrUndefined(this._spanElementRef.current, "this._spanElementRef.current");

        this._spanElementRef.current.text(change.currentValue);
    }

    // #endregion

    // #endregion
}

